import React, { useState } from 'react';
import { ArrowLeft, Loader2 } from 'lucide-react';
interface BookingPageProps {
  onBack?: () => void;
}
export function BookingPage({
  onBack
}: BookingPageProps) {
  const [isLoading, setIsLoading] = useState(true);
  return <main className="min-h-screen w-full bg-background text-foreground bg-noise selection:bg-blue-500/30 overflow-x-hidden" data-id="element-133">
      {/* Header */}
      <div className="w-full border-b border-white/5 bg-[#0a0a0f]/80 backdrop-blur-md sticky top-0 z-50" data-id="element-134">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between" data-id="element-135">
          <button onClick={onBack} className="flex items-center gap-2 text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-136">
            <ArrowLeft className="w-4 h-4" data-id="element-137" />
            <span data-id="element-138">Back</span>
          </button>
          <span className="label-caps text-[10px] sm:text-[11px] text-gray-500 tracking-[0.1em]" data-id="element-139">
            Faceless YouTube System
          </span>
        </div>
      </div>

      {/* Booking Content */}
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-10 md:py-16 relative z-10" data-id="element-140">
        <div className="text-center mb-8 md:mb-10" data-id="element-141">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white tracking-[-0.03em] mb-3" data-id="element-142">
            Book Your <span className="text-gradient" data-id="element-143">Strategy Call</span>
          </h1>
          <p className="text-xs sm:text-sm text-gray-400 max-w-md mx-auto leading-relaxed tracking-[0.01em]" data-id="element-144">
            Pick a time that works for you. We'll map out your faceless channel
            strategy and show you exactly how to get started.
          </p>
        </div>

        {/* Booking Widget */}
        <div className="glass-panel rounded-2xl md:rounded-3xl p-2 sm:p-4 md:p-6 border border-white/10 relative" data-id="element-145">
          {/* Loading indicator */}
          {isLoading && <div className="absolute inset-0 flex items-center justify-center z-10 rounded-2xl md:rounded-3xl bg-[#0a0a0f]/80" data-id="element-146">
              <div className="flex flex-col items-center gap-3" data-id="element-147">
                <Loader2 className="w-8 h-8 text-blue-500 animate-spin" data-id="element-148" />
                <p className="text-sm text-gray-400" data-id="element-149">Loading booking form...</p>
              </div>
            </div>}
          <iframe src="https://link.yourmarketingai.com/widget/booking/JKArLbQnkP5mySNU1Ztc" style={{
          width: '100%',
          minHeight: '900px',
          border: 'none',
          borderRadius: '1rem'
        }} scrolling="yes" id="JKArLbQnkP5mySNU1Ztc_1770981664093" onLoad={() => setIsLoading(false)} data-id="element-150" />
        </div>

        {/* Trust text */}
        <p className="label-caps text-[9px] md:text-[10px] text-gray-500 text-center mt-6 tracking-[0.12em]" data-id="element-151">
          Free consultation. No commitment required.
        </p>
      </div>

      {/* Background orbs */}
      <div className="fixed top-0 right-0 w-[400px] h-[400px] bg-blue-600/5 rounded-full blur-[120px] translate-x-1/3 -translate-y-1/4 pointer-events-none" data-id="element-152" />
      <div className="fixed bottom-0 left-0 w-[400px] h-[400px] bg-purple-600/5 rounded-full blur-[120px] -translate-x-1/3 translate-y-1/4 pointer-events-none" data-id="element-153" />
    </main>;
}